import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

// i18n
import { useTranslation } from "react-i18next";

// users
import avatar2 from '../../../assets/images/users/avatar-2.jpg';

const ProfileMenu = () => {
    const { t } = useTranslation();
    const [menu, setMenu] = useState(false);
    const [userInfo, setUserInfo] = useState("Admin");
    console.log('userInfo', userInfo);

    useEffect(() => {
        const authUser = localStorage.getItem("authUser");
        if (authUser) {
            const obj = JSON.parse(authUser);
            const username = obj.userName || obj.userEmail?.split("@")[0];
            if (username) {
                const capitalized = username.charAt(0).toUpperCase() + username.slice(1);
                setUserInfo(capitalized);
            }
        }
    }, []);

    const toggle = () => {
        setMenu(prev => !prev);
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block user-dropdown">
                <DropdownToggle tag="button" className="btn header-item waves-effect" id="page-header-user-dropdown">
                    <img className="rounded-circle header-profile-user me-1" src={avatar2} alt="Header Avatar" />
                    <span className="d-none d-xl-inline-block ms-1 text-transform">{userInfo}</span>
                    <i className="mdi mdi-chevron-down d-none ms-1 d-xl-inline-block"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem href="#"><i className="ri-user-line align-middle me-1"></i> {t('Profile')}</DropdownItem>
                    <DropdownItem href="#"><i className="ri-wallet-2-line align-middle me-1"></i> {t('My Wallet')}</DropdownItem>
                    <DropdownItem className="d-block" href="#">
                        <span className="badge badge-success float-end mt-1">11</span>
                        <i className="ri-settings-2-line align-middle me-1"></i> {t('Settings')}
                    </DropdownItem>
                    <DropdownItem href="#"><i className="ri-lock-unlock-line align-middle me-1"></i> {t('Lock screen')}</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="text-danger" href="/logout">
                        <i className="ri-shut-down-line align-middle me-1 text-danger"></i> {t('Logout')}
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileMenu;
